var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.25C8.84674 5.25 9.41903 5.48705 9.84099 5.90901C10.2629 6.33097 10.5 6.90326 10.5 7.5V16.5C10.5 17.0967 10.2629 17.669 9.84099 18.091C9.41903 18.5129 8.84674 18.75 8.25 18.75C7.65326 18.75 7.08097 18.5129 6.65901 18.091C6.23705 17.669 6 17.0967 6 16.5V7.5C6 6.90326 6.23705 6.33097 6.65901 5.90901C7.08097 5.48705 7.65326 5.25 8.25 5.25ZM15.75 5.25C16.3467 5.25 16.919 5.48705 17.341 5.90901C17.7629 6.33097 18 6.90326 18 7.5V16.5C18 17.0967 17.7629 17.669 17.341 18.091C16.919 18.5129 16.3467 18.75 15.75 18.75C15.1533 18.75 14.581 18.5129 14.159 18.091C13.7371 17.669 13.5 17.0967 13.5 16.5V7.5C13.5 6.90326 13.7371 6.33097 14.159 5.90901C14.581 5.48705 15.1533 5.25 15.75 5.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsPause);
export default __webpack_public_path__ + "static/media/bsPause.7e332ba70a9e5352fa67d513712ecc08.svg";
export { ForwardRef as ReactComponent };